import URI from 'urijs';

var CivicActionCenter = function() {
    var CivicActionCenter = {
        shortUrl: null,
        encryptedId: null,
        states: null,
        isWidget: false,
    };

    CivicActionCenter.init = function() {
        window.onpopstate = function(event) {
            var newState = null;
            try {
                newState = event.state.requestedAction;
            } catch (eventException) {}

            //If no state, "go home"
            if (!newState) {
                $('.close-advocate-information-container a').trigger('click');
            } else {
                $('[data-requested-action="' + newState + '"]:visible:first').trigger('click');
            }
        };

        $(function() {
            var $multiListing = $('.multi-listing');
            var $listingActionButton = $('.listing-action-button', $multiListing);
            var $requestAdvocateInformation = $('#request-advocate-information');
            var $requestAdvocateInformationForm = $('#request-advocate-information-form');
            var $advocateInfoEntry = $('.advocate-info-entry', $requestAdvocateInformationForm);
            var $splashPageFootnote = $('#civicactioncenter-splash-page .footnote');
            var $topnavHamburger = $('#civicactioncenter-topnav-hamburger');

            $listingActionButton.click(function() {
                var $me = $(this);

                var requestedAction = $me.attr('data-requested-action');
                if (requestedAction === 'absenteeballot') {
                    var url = '/' + CivicActionCenter.shortUrl + '/civicactioncenter/absenteeballot';
                    url = CivicActionCenter.addIdToUrl(url);
                    window.open(url, '_blank');
                    return false;
                }

                var originalRequestedAction = requestedAction;

                var uri = new URI();
                var p2asource = CivicActionCenter.getP2ASource(uri);
                if (p2asource) {
                    uri.setSearch('p2asource', p2asource)
                }
                uri.setSearch('action', requestedAction);

                window.history.pushState({
                    requestedAction
                }, '', uri.search());

                //Add the title description, and submit button
                var actionInfoData = window.P2A.CivicActionCenter.actionsInfo;

                $('.request-title', $requestAdvocateInformation).html(actionInfoData[requestedAction].title);
                $('.request-description', $requestAdvocateInformation).html(actionInfoData[requestedAction].description);
                $('.submit-text', $requestAdvocateInformation).html(actionInfoData[requestedAction].buttonSubmit);
                $('.consent-language p', $requestAdvocateInformation).html(actionInfoData[requestedAction].privacyConsentLanguage);

                //Now that we've set the ui, use registertovote actions
                if (originalRequestedAction == 'checkregistration') {
                    requestedAction = 'registertovote';
                }

                var $notRelevantDivs = $('div.cac-input', $advocateInfoEntry).not('[data-' + requestedAction + ']');
                $notRelevantDivs.hide();
                $(':input', $notRelevantDivs).prop('disabled', true);

                //Show the relevant fields for this action type
                var $relevantDivs = $('div[data-' + requestedAction + '].cac-input');
                $relevantDivs.show();
                $relevantDivs.children().show();
                $(':input', $relevantDivs).prop('disabled', false);

                //Close not relevant divs inside of the optins
                var $optInsContainer = $('.optins-container', $advocateInfoEntry);
                $notRelevantDivs = $('div', $optInsContainer).not('[data-' + requestedAction + ']');
                $notRelevantDivs.hide();
                $(':input', $notRelevantDivs).prop('disabled', true);

                if (requestedAction == 'registertovote') {
                    $requestAdvocateInformationForm.attr('data-registertovote-submit', '');
                } else {
                    $('button[type="submit"]', $requestAdvocateInformationForm).removeAttr('data-registertovote-submit');
                }

                $multiListing.slideUp(400);
                $requestAdvocateInformation.slideDown(400);
                $('#civicactioncenter-topnav-desktop').slideDown(400);

                $('[name="requested-action"]', $requestAdvocateInformation).val(originalRequestedAction);

                //Remove all active buttons and mark our current section
                var $civicActionCenterTopNav = $('.civicactioncenter-topnav');
                $('.topnav-button', $civicActionCenterTopNav).removeClass('active-topnav-button');
                $('.topnav-button[data-requested-action="' + originalRequestedAction + '"]', $civicActionCenterTopNav).addClass('active-topnav-button');

                $splashPageFootnote.hide();

                if (CivicActionCenter.isWidget === true) {
                    window.parent.postMessage('advocacyWidgetScrollToTop', '*');
                    $("html, body").animate({
                        scrollTop: 0
                    }, "slow");
                }

                return false;
            });

            $requestAdvocateInformationForm.submit(function(e) {
                e.preventDefault();
                var $me = $(this);
                var $submitButton = $('button[type="submit"]', $me);

                CivicActionCenter.hideFormError();

                window.P2A.Helpers.Ajax.loadingStarted($submitButton);

                var windowUri = new URI();
                var uri = '/' + window.P2A.CivicActionCenter.shortUrl;
                if (CivicActionCenter.isWidget === true) {
                    windowUri = new URI(document.referrer);
                    uri = '/embed/widget/app' + uri;
                }

                var p2asource = CivicActionCenter.getP2ASource(windowUri);
                if (p2asource) {
                    uri += "?p2asource=" + p2asource;
                }

                var params = {
                    method: 'POST'
                };

                params.data = window.P2A.Helpers.Forms.SerializeToObject($requestAdvocateInformationForm.serializeArray());

                var onSuccess = function(returnData) {
                    window.P2A.Helpers.Ajax.loadingCompleted($submitButton);

                    if (!returnData) {
                        return false;
                    }

                    if (returnData.error) {
                        CivicActionCenter.showFormError(returnData.error);
                        return false;
                    }

                    // Fire successful submission event
                    $.event.trigger({
                        type: "action",
                        message: params.data['requested-action']
                    });

                    if (returnData.encryptedId) {
                        CivicActionCenter.encryptedId = returnData.encryptedId;
                    }

                    if (CivicActionCenter.isWidget === true) {
                        window.parent.postMessage('advocacyWidgetScrollToTop', '*');
                        $("html, body").animate({
                            scrollTop: 0
                        }, "slow");
                    }

                    if (returnData.redirect) {
                        // show the loading icon while redirecting the advocate
                        window.P2A.Helpers.Ajax.loadingStarted($submitButton);
                        window.location.href = returnData.redirect;
                        return false;
                    } else if (returnData.registeredToVote === false) {
                        CivicActionCenter.RegisterToVote.displayNotRegisteredToVote(returnData);
                    }

                    return false;
                };
                var onError = function(w, t, f) {
                    window.P2A.Helpers.Ajax.loadingCompleted($submitButton);

                };
                window.P2A.Helpers.Ajax.send(uri, params, onSuccess, onError);
            });

            $requestAdvocateInformation.on('click', '.close-advocate-information-container a', function() {
                $multiListing.slideDown(400);
                $requestAdvocateInformation.slideUp(400);
                $('#civicactioncenter-topnav-desktop').slideUp(400);

                $('.civicactioncenter-topnav .topnav-button').removeClass('active-topnav-button');

                $splashPageFootnote.show();

                var newUrl = window.P2A.Helpers.Urls.removeParameter('action', window.location.href);
                window.history.pushState('', '', newUrl);

                return false;
            });

            //Send advocate to data-href links
            $('[data-href]').click(function() {
                var $me = $(this);
                var requestedAction = $me.attr('data-requested-action');
                var $civicActionCenterSplashPage = $('#civicactioncenter-splash-page');
                if ($civicActionCenterSplashPage.length && requestedAction) {
                    //If we are on the front page, don't redirect them - just trigger a different action form
                    $('[data-requested-action="' + requestedAction + '"]', $civicActionCenterSplashPage)
                        .not('[data-href]')
                        .first()
                        .trigger('click');
                } else {
                    var redirectTo = $me.attr('data-href');
                    if (requestedAction === 'absenteeballot') {
                        window.open(redirectTo, '_blank');
                    } else {
                        window.location.href = redirectTo;
                    }
                }
                return false;
            });

            $('[data-absentee-ballot-link]').click(function() {
                var uri = '/' + window.P2A.CivicActionCenter.shortUrl + '/civicactioncenter/absenteeballotclick';
                uri += '?id=' + $('[name="id"]').val();
                var params = {
                    method: 'POST'
                };

                params.data = {};

                window.P2A.Helpers.Ajax.send(uri, params);
            });

            var todayAgeSeventeen = new Date(new Date().setFullYear(new Date().getFullYear() - 17));

            $topnavHamburger.on('show.bs.collapse', function() {
                var $hamburgerButtonFA = $('.hamburger-button i', $topnavHamburger);
                $hamburgerButtonFA.removeClass('fa-chevron-down');
                $hamburgerButtonFA.addClass('fa-chevron-up');
            });
            $topnavHamburger.on('hide.bs.collapse', function() {
                var $hamburgerButtonFA = $('.hamburger-button i', $topnavHamburger);
                $hamburgerButtonFA.removeClass('fa-chevron-up');
                $hamburgerButtonFA.addClass('fa-chevron-down');
            });
        });
    };


    CivicActionCenter.showFormError = function(errormessage) {
        var $alertContainer = $('#request-advocate-information .alert-container');
        if ($('.alert-danger', $alertContainer).length <= 0) {
            var message = '<div class="alert alert-danger" style="display: none;">';
            message += errormessage;
            message += '</div>';

            $alertContainer.prepend(message);
            //Ease it in
            $('.alert-danger', $alertContainer).show(function() {
                var $me = $(this);

                window.parent.postMessage('advocacyWidgetScrollToTop', '*');

                $('html, body').animate({
                    scrollTop: $me.offset().top
                }, 400);
            });
        } else {
            $('.alert-danger', $alertContainer).html(errormessage);
            //Ease it in
            $('.alert-danger', $alertContainer).show(function() {
                var $me = $(this);

                window.parent.postMessage('advocacyWidgetScrollToTop', '*');

                $('html, body').animate({
                    scrollTop: $me.offset().top
                }, 400);
            });
        }
    };

    CivicActionCenter.hideFormError = function(errormessage) {
        var $alertContainer = $('#request-advocate-information .alert-container');
        var $alertDanger = $('.alert-danger', $alertContainer);
        $alertDanger.html('');
        $alertDanger.hide();
    };

    CivicActionCenter.addIdToUrl = function(url) {
        if (CivicActionCenter.encryptedId) {
            var id = window.P2A.Helpers.Urls.getParameterByName('id', url);
            if (!id) {
                url = window.P2A.Helpers.Urls.addParameter('id', CivicActionCenter.encryptedId, url);
            }
        }

        return url;
    };

    CivicActionCenter.getP2ASource = function(uri) {
        return uri.search(true).p2asource;
    }

    return CivicActionCenter;
};

export default CivicActionCenter;
